import { connect } from 'react-redux';
import { RootState } from 'store/types';
import OptionsConfirmation from './OptionsConfirmation';
import { confirmGuestOption, fetchGuestData } from 'store/Guests/thunks';

const mapStateToProps = (state: RootState) => ({
  packSummary: state.packs.packSummary,
});

const mapDispatchToProps = {
  confirmGuestOption,
  fetchGuestData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OptionsConfirmation);
